import { z } from "zod";

const searchType = z.enum(["titleUk", "titleUs", "address", "sites"]);

export const findByTitleToolMatchSchema = z.object({
  id: z.string().describe("ID of the item in the search"),
  match: z.string().describe("The matched item from the search term"),
  matchType: searchType.describe("The type of the match"),
});

export const findByTitleToolSchema = {
  inputSchema: z.object({
    searchType: searchType.nullable().describe("The type of the search"),
    searchTerm: z.string().describe('A UK Title number examples are "AB123456" or "AB123456789"'),
  }),
  outputSchema: z.object({
    success: z.boolean().describe("If the search was successful"),
    exactMatch: findByTitleToolMatchSchema.nullable(),
    otherMatches: z.array(findByTitleToolMatchSchema),
  }),
};

export type FindByTitleToolInput = z.infer<typeof findByTitleToolSchema.inputSchema>;
export type FindByTitleToolOutput = z.infer<typeof findByTitleToolSchema.outputSchema>;
